import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { formatDate, SubmitButton } from "../../Components/InputElements";
import { currentDateAndTime } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { decodeData } from "../../Constants/constants";
import { useLocation } from "react-router-dom";
function LeaveDataImporting() {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [loading, setLoading] = useState(false);
    const [loadingLeaveImportExcel, setLoadingLeaveImportExcel] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const limitOptions = [10, 25, 50, 100, 200, 500]
    // const [onboardingData, setOnboardingData] = useState([]);
    const [leaveBalanceData, setLeaveBalanceData] = useState([]);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: '',
        total_pages: '',
        limit: 10
    });
    const [limitAction, setLimitAction] = useState(false);
    const[loadingDownload, setLoadingDownload] = useState(false);
    const [uploadLeaveSheets, setUploadLeaveSheet] = useState({
        file: null,
        remarks: "",
        leaveBalance: true,
        leaveHistory: true,
    });
    const fileInputRef = useRef(null);

    const downloadButton = async (id, excelName) => {
        setLoadingDownload(id);
        try {
            const response = await fetch(`${apiURL}Employees/DownloadOnboardExcel/${id}`, {
                headers: apiHeaderJSON,
            });
            // console.log("=======>>>>", response);
            // Check if the response is okay
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${excelName.includes('.xlsx') ? excelName?.split(".xlsx")[0] : excelName }.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setSuccessMsg("Excel Downloaded Successfully!!");
            setLoadingDownload(false);
            // Clean up the URL object
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingDownload(false);
            setErrorMsg("There was a problem with the download!! Please try again later.");
        }
    }

    const handleLeaveExcelDownload = async () => {
        const headers = apiHeaderJSON;
        const data = {
            activated: "1",
            LeaveBalance: true ,
            date: currentDateAndTime(),
        }
        console.log("ExportEmployeeLeaveDataToExcel => formData",data);
        console.log("ExportEmployeeLeaveDataToExcel => formData",data.date);
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
      
        axios.post(`${apiURL}Employees/ExportEmployeeLeaveDataToExcel`, data, {
            headers
        })
            .then(async (response) => {
                const { success, employee_leave_data, message } = response.data;
      
                if (success === true) {
                    // Create a new workbook
                    const workbook = XLSX.utils.book_new();
      
                    // Function to create worksheet for a category
                    const createWorksheet = (dataArray, sheetName) => {
                        const worksheetArray = [];
      
                        // If it's a 2D array, map each sub-array
                        if (Array.isArray(dataArray[0])) {
                            dataArray.forEach(subArray => {
                                worksheetArray.push(subArray);
                            });
                        } else {
                            // Otherwise, just use the single array
                            worksheetArray.push(dataArray);
                        }
      
                        const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
                        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    };
      
                    // Leave Balance Sheet
                    if (employee_leave_data.LeaveBalance) {
                        createWorksheet(employee_leave_data.LeaveBalance, 'LeaveBalance');
                    }
      
                    const file_name = `Employee Leave Balance.xlsx`;
      
                    // Write the workbook to an Excel file
                    XLSX.writeFile(workbook, file_name);
      
                    Swal.close();
                    Swal.fire({
                        title: `<strong>Success</strong>`,
                        text: message,
                        icon: 'success',
                        showConfirmButton: true
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: `<strong>Failed</strong>`,
                        text: message,
                        icon: 'error',
                        showConfirmButton: true
                    });
                }

            })
            .catch((error) => {

                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: error.response ? error.response.message : error.message,
                    icon: 'error',
                    showConfirmButton: true
                });
            });
      };
    

    const getEmployeeLeaveBalanceData = () => {
        const options = {
            url: `${apiURL}Employees/GetEmployeeLeaveBalance?limit=${pagination?.limit}&page=${pagination?.page}`,
            method: "GET",
            headers: apiHeaderJSON,
        }
        axios(options)
            .then((response) => {
                // console.log("getEmployeeOnboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    // console.log("getEmployeeOnboardingData ~ res", res);
                    setLeaveBalanceData(res?.data);
                    setPagination({
                        ...pagination,
                        next: res?.next,
                        prev: res?.prev,
                        page: res?.page,
                        total_records: res?.total_records,
                        total_pages: res?.total_pages
                    });
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }

                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.data?.message);
                setLoading(false);
            });

    }
    useEffect(() => {
        setLoading(true);
        getEmployeeLeaveBalanceData();
    }, []);


    const handleDeleteExcel = (id) => {
     
        const options = {
            url: `${apiURL}Masters/DeleteEmployeeLeaveBalanceExcelFile/${id}`,
            method: "DELETE",
            headers: apiHeaderJSON,  
            data:{
                date:currentDateAndTime(),
            }
           }
        Swal.fire({
            title: "Are you sure?",
            text: `If you delete this file, You won't able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete!",
            cancelButtonText: "No, Cancel!",
            allowOutsideClick: false,
          }).then((result) => {
        if (result.isConfirmed) {
            setLoadingDelete(id);
            axios(options)
            .then((response) => {
                // console.log("getEmployeeOnboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    console.log("handleDeleteExcel ~ res", res);
                    setSuccessMsg("Excel Deleted Successfully!!");
                    getEmployeeLeaveBalanceData();
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }

                setLoadingDelete(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.data?.message);
                setLoadingDelete(false);
            });
            }
        })

    }

    function uploadLeaveBalance() {
        setLoadingLeaveImportExcel(true);
    
        // Create FormData instance
        let formData = new FormData();
    
        // Add file and other fields to formData
        formData.append('file', uploadLeaveSheets.file);
        formData.append('remarks', uploadLeaveSheets.remarks);
        formData.append('date', currentDateAndTime());
    
        const header = {
            ...apiHeaderFile,        }
    
        console.log("ImportLeaveBalance ~ formData", formData);
        
        const options = {
            url: `${apiURL}Employees/ImportLeaveBalance`,
            method: "POST",
            headers: header,
            data: formData,
            date: currentDateAndTime()
            
        };
    
        axios(options)
            .then((response) => {
                console.log("ImportLeaveBalance ~ response", response?.data);
                if (response?.data?.success === true) {
                    setSuccessMsg(response?.data?.message);
                    setUploadLeaveSheet({
                        file: null,
                        remarks: "",
                        leaveBalance: true,
                        leaveHistory: true,
                    });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                      }
                    getEmployeeLeaveBalanceData();

                } else if (response?.data?.success === false) {
                    setErrorMsg(response?.data?.message || "There is a problem to upload excel!!");
                }
                setLoadingLeaveImportExcel(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.response?.data?.message || "There is a problem to upload excel!!");
                setLoadingLeaveImportExcel(false);
            });
    }
    const handleLeaveSubmit = (e) => {
        e.preventDefault();
        if (uploadLeaveSheets.file) {
            uploadLeaveBalance();
        }
        else if (
            !uploadLeaveSheets.file
        ) {
            setErrorMsg("Please select excel file to upload data.");
        } 
    }

    useEffect(()=>{
        if(limitAction){
        getEmployeeLeaveBalanceData();
        setLimitAction(false);
        }
    },[limitAction]);

    const handleLimitChange = e => {
        console.log(e.target.value)
        setPagination({
        ...pagination,
        limit: e.target.value,
        page: 1
        })
        setLimitAction(true)
    }

  const handlePageChange = e => {
    console.log(e.target.value)
    setPagination({
      ...pagination,
      page: parseInt(e.target.value)
    })
    setLimitAction(true)
  }
  const handlePrev = () => {
    console.log(pagination?.prev)
    if (pagination?.prev === true) {
      console.log(pagination?.page - 1)
      setPagination({
        ...pagination,
        page: pagination?.page - 1
      })
    }
    setLimitAction(true)
  }
  const handleNext = () => {
    console.log(pagination?.next)
    if (pagination?.next === true) {
      console.log(pagination?.page + 1)
      setPagination({
        ...pagination,
        page: pagination?.page + 1
      })
    }
    // getList();
    setLimitAction(true)
  }

    // console.log("success", successMsg);

    return (
        <section>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Leave Import`} primary={`Home`} />
                            <div className="card">
                                <div className="card-header align-items-center justify-content-between d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">{"Leave Balance Import"}</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label htmlFor="keyword">File Upload</label>
                                            <div className="input-group">
                                                <input type="file" ref={fileInputRef} onChange={(e) => { setUploadLeaveSheet({ ...uploadLeaveSheets, file: e.target.files[0] }) }} accept=".xlsx" className="form-control" name="fileUpload" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="File Upload" disabled={(!decodedData?.includes(6)) } />

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="keyword">Remarks</label>
                                            <div className="input-group">
                                                <input type="text" value={uploadLeaveSheets?.remarks} onChange={(e) => { setUploadLeaveSheet({ ...uploadLeaveSheets, remarks: e.target.value }) }} className="form-control" name="remarks" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Remarks" disabled={(!decodedData?.includes(6)) } />
                                            </div>
                                        </div>
                                        {(decodedData?.includes(6)) && (
                                            <div className="col-md-4">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label htmlFor="keyword">Upload</label>
                                                        <div>
                                                            {/* {!loadingLeaveImportExcel ?
                                                            
                                                                <button type="button" onClick={(e) => handleLeaveSubmit(e)} className={`btn btn-info btn-label waves-effect waves-light w-100 ${uploadLeaveSheets?.file ? "" : "disabled"}`}>
                                                                    <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Upload
                                                                </button> :
                                                                <button type="button" className={`btn btn-info btn-label waves-effect waves-light w-100`}>
                                                                    <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Processing...
                                                                </button>
                                                            } */}
                                                            <SubmitButton otherClasses='w-100' loadingClasses='w-100' onClick={(e)=>{ 
                                                                if(!loadingLeaveImportExcel){
                                                                    handleLeaveSubmit(e)
                                                                }
                                                            }}
                                                            loading={loadingLeaveImportExcel} disabled={!uploadLeaveSheets?.file} 
                                                            loadingMessage='Processing' buttonName={'Upload'} icon={'bx bx-cloud-upload'} 
                                                            type='info' iconSide='left' />
                                                        </div>
                                                    </div>
                                                    { decodedData?.includes(6) &&(
                                                    <div className='col-md-6'>
                                                        <div>
                                                            <label>Leave Balance</label>
                                                        </div>
                                                        {/* <button
                                                            type="button"
                                                            onClick={handleLeaveExcelDownload}
                                                            disabled={loadingLeaveImportExcel}
                                                            className={` noWrap btn btn-success btn-label waves-effect waves-light`}>
                                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                            Download Excel
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={() => {handleLeaveExcelDownload()}}
                                                        disabled={loadingLeaveImportExcel} 
                                                        buttonName={'Download Excel'} icon={'ri-file-excel-line'} 
                                                        type='success' iconSide='left' />
                                                    </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {/* { decodedData?.includes(6) &&(
                                        <div style={{ width: "17%" }} className='col-md-3'>
                                            <div>
                                                <label>Sample Excel</label>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={handleExcelDownload}
                            
                                                className={` noWrap btn btn-success btn-label waves-effect waves-light`}>
                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                Download Excel
                                            </button>
                                        </div>
                                        )} */}
                                        
                                    </div>
                                    {successMsg ?
                                        <div className=" position-relative alert alert-success mt-3" role="alert">
                                            {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div>
                                        : null
                                    }
                                    {errorMsg ?
                                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                                            {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div> : null
                                    }                                       
                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                                        <table className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed table-hover" style={{ width: '100%' }} aria-describedby="example_info">
                                            <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                <tr>
                                                    <th >ID</th>
                                                    <th >Upload Date</th>
                                                    <th >File Name</th>
                                                    <th >Remarks</th>

                                                        <th className=' text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(leaveBalanceData) && leaveBalanceData?.length >= 1 ?
                                                    <>
                                                        {leaveBalanceData?.map((val, index) => {
                                                            return (
                                                                <>
                                                                    {index % 2 === 0 ?
                                                                        <tr key={val?.id} className="odd">
                                                                            <td>{index + 1}</td>
                                                                            <td>{formatDate(val?.updated_date)} </td>
                                                                            <td onClick={(e) => {
                                                                                downloadButton(val?.id, val?.file_name?.split("/")[val?.file_name?.split("/").length - 1])
                                                                            }}
                                                                                className="" >
                                                                                {loadingDownload === val?.id ?
                                                                                    <div className="text-center">
                                                                                        <div className="spinner-border text-primary" role="status">
                                                                                            <span className="visually-hidden">Loading...</span>
                                                                                        </div>
                                                                                    </div> :
                                                                                    <p className=" hoverBlue cursorPointer">{val?.file_name?.split("/")[val?.file_name?.split("/").length - 1]}</p>
                                                                                }
                                                                            </td>
                                                                            <td>{val?.remarks}</td>
                                                                            <td className=' text-center'>
                                                                                {loadingDelete === val?.id ?
                                                                                    <button
                                                                                        type="button" class="btn btn-danger bg-danger text-light F "
                                                                                    >Loading...</button> :
                                                                                    <button
                                                                                        onClick={() => { handleDeleteExcel(val?.id) }} type="button" class="btn btn-danger bg-danger text-light waves-effect "
                                                                                    >Delete</button>
                                                                                }
                                                                            </td>
                                                                        </tr> :
                                                                        <tr key={val?.id} className="even">
                                                                            <td>{index + 1}</td>
                                                                            <td>{formatDate(val?.updated_date)} </td>
                                                                            <td onClick={(e) => {
                                                                                downloadButton(val?.id, val?.file_name?.split("/")[val?.file_name?.split("/").length - 1])
                                                                            }}
                                                                                className="" >
                                                                                {loadingDownload === val?.id ?
                                                                                    <div className="text-center">
                                                                                        <div className="spinner-border text-primary" role="status">
                                                                                            <span className="visually-hidden">Loading...</span>
                                                                                        </div>
                                                                                    </div> :
                                                                                    <p className="hoverBlue cursorPointer ">{val?.file_name?.split("/")[val?.file_name?.split("/").length - 1]}</p>
                                                                                }
                                                                            </td>
                                                                            <td>{val?.remarks}</td>
                                                                            <td className=' text-center'>
                                                                                {loadingDelete === val?.id ?
                                                                                    <button
                                                                                        type="button" class="btn btn-danger bg-danger text-light F "
                                                                                    >Loading...</button> :
                                                                                    <button
                                                                                        onClick={() => { handleDeleteExcel(val?.id) }} type="button" class="btn btn-danger bg-danger text-light waves-effect "
                                                                                    >Delete</button>
                                                                                }
                                                                            </td>
                                                                        </tr>

                                                                    }
                                                                </>
                                                            )
                                                        })

                                                        }

                                                    </>
                                                    :
                                                    <td colSpan={5}>
                                                        <NoRecords />
                                                    </td>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                        <button disabled={!pagination?.prev} type='button' onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                                        <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />
                                        Previous
                                        </button>
                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                            {<small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>}
                                        </div>
                                        <div className='col-md-2'>
                                            <select className='form-select' onChange={e => { handlePageChange(e) }}>
                                                {Array.from({ length: pagination?.total_pages },
                                                (_, i) => (
                                                    <option selected={pagination?.page === i + 1} key={i} value={i + 1}>
                                                    Page {i + 1}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='col-md-2'>
                                            <select className='form-select' onChange={handleLimitChange} value={pagination?.limit}>
                                                {limitOptions.map(option => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                                ))}
                                            </select>
                                        </div>
                                        <button disabled={!pagination?.next} type='button' onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}>
                                        <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                                        Next
                                        </button>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </section >
    );
}

export default LeaveDataImporting;